import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  async getAwards(accessToken) {
	  let res = await axios.get(API_NAME + "/epic_awards", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getUserProfile(accessToken) {
	  let res = await axios.get(API_NAME + "/epic_users/self", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getOrganisations(accessToken) {
	  let res = await axios.get(API_NAME + "/organisations", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getMyOrganisations(accessToken) {
	  let res = await axios.get(API_NAME + "/organisations/myself", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getVolunteers(accessToken) {
	  let res = await axios.get(API_NAME + "/epic_users?volunteer=1", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getVolunteer(accessToken, id) {
	  let res = await axios.get(API_NAME + "/epic_users/" + id, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async saveVolunteer(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/epic_users",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveOrganisationUser(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/epic_users",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveAward(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/epic_awards",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async saveOrganisation(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/organisations",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async saveUserOrganisation(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/user_organisations",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async getOrganisation(accessToken, id) {
	  let res = await axios.get(API_NAME + "/organisations/" + id, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async saveEpicHours(accessToken, formdata) {
    let res = await axios.post(API_NAME + "/epic_hours",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async createAuth0UserLogin(accessToken, user_id, formdata) {
    let res = await axios.post(API_NAME + "/users/" + user_id + "/create_auth0",  formdata,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      
    return res.data;
  },
  
}